module.exports = require("./ca-ES-VALENCIA.d.ts");